// extracted by mini-css-extract-plugin
export var formContainer = "_du-0";
export var message = "_du-1";